// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image {
    padding: 16px;
    border-radius: 5px;
    border: 2px solid #0000;
    background:
        linear-gradient(black, #222) padding-box,
        linear-gradient(#09f, white) border-box;
    background-color: rgba(0, 0, 0, 0.5);
}

.p {
    border-radius: 5px;
    border: 2px solid #0000;
    background:
        linear-gradient(black, #222) padding-box,
        linear-gradient(#09f, white) border-box;
    background-color: rgba(0, 0, 0, 0.5);
}

.imageProjects {
    padding: 8px;
    border-radius: 10px;
    border: 3px solid #0000;
    background:
        linear-gradient(black, #222) padding-box,
        linear-gradient(#09f, white) border-box;
}

.tags{
    padding: 8px;
    border-radius: 10px;
    border: 3px solid #0000;
    background:
        linear-gradient(black, #808080) padding-box,
        linear-gradient(#09f, white) border-box;
}

.links{
    padding: 8px;
    border-radius: 20px;
    border: 3px solid #0000;
    background:
        linear-gradient(black, #656565) padding-box,
        linear-gradient(#09f, white) border-box;
}

.linksSocial{
    padding: 10px;
    border-radius: 25px;
    border: 4px solid #0000;
    background:
        linear-gradient(black, #656565) padding-box,
        linear-gradient(#09f, white) border-box;
}

.menuItems{
    padding: 6px;
    border-radius: 25px;
    border: 4px solid #0000;
    background:
        linear-gradient(black, #656565) padding-box,
        linear-gradient(#09f, white) border-box;
}`, "",{"version":3,"sources":["webpack://./src/components/imageCards.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB;;+CAE2C;IAC3C,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB;;+CAE2C;IAC3C,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB;;+CAE2C;AAC/C;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB;;+CAE2C;AAC/C;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB;;+CAE2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB;;+CAE2C;AAC/C;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB;;+CAE2C;AAC/C","sourcesContent":[".image {\n    padding: 16px;\n    border-radius: 5px;\n    border: 2px solid #0000;\n    background:\n        linear-gradient(black, #222) padding-box,\n        linear-gradient(#09f, white) border-box;\n    background-color: rgba(0, 0, 0, 0.5);\n}\n\n.p {\n    border-radius: 5px;\n    border: 2px solid #0000;\n    background:\n        linear-gradient(black, #222) padding-box,\n        linear-gradient(#09f, white) border-box;\n    background-color: rgba(0, 0, 0, 0.5);\n}\n\n.imageProjects {\n    padding: 8px;\n    border-radius: 10px;\n    border: 3px solid #0000;\n    background:\n        linear-gradient(black, #222) padding-box,\n        linear-gradient(#09f, white) border-box;\n}\n\n.tags{\n    padding: 8px;\n    border-radius: 10px;\n    border: 3px solid #0000;\n    background:\n        linear-gradient(black, #808080) padding-box,\n        linear-gradient(#09f, white) border-box;\n}\n\n.links{\n    padding: 8px;\n    border-radius: 20px;\n    border: 3px solid #0000;\n    background:\n        linear-gradient(black, #656565) padding-box,\n        linear-gradient(#09f, white) border-box;\n}\n\n.linksSocial{\n    padding: 10px;\n    border-radius: 25px;\n    border: 4px solid #0000;\n    background:\n        linear-gradient(black, #656565) padding-box,\n        linear-gradient(#09f, white) border-box;\n}\n\n.menuItems{\n    padding: 6px;\n    border-radius: 25px;\n    border: 4px solid #0000;\n    background:\n        linear-gradient(black, #656565) padding-box,\n        linear-gradient(#09f, white) border-box;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
